import { languageService } from "../../../Language/language.service";

export const HOS_RECORD_ENTRY_PHASE = {
  VIEWONLY: {
    prevPhase: null,
    currPhase: "VIEWONLY",
    nextPhase: null,
    currTitle: languageService("Select Input Mode"),
    nextTitle: null,
  },
  PRESUBMITTED: {
    prevPhase: null,
    currPhase: "PRESUBMITTED",
    nextPhase: null,
    nextTitle: null,
  },
  DRAFT: {
    prevPhase: "VIEWONLY",
    currPhase: "DRAFT",
    nextPhase: "REVIEWINPROGRESS",
    currTitle: languageService("Add Activity"),
    nextTitle: "Next",
  },
  REVIEWINPROGRESS: {
    prevPhase: "DRAFT",
    currPhase: "REVIEWINPROGRESS",
    nextPhase: "REVIEW",
  },
  REVIEW: {
    prevPhase: "DRAFT",
    currPhase: "REVIEW",
    nextPhase: "SUBMITINPROGRESS",
    currTitle: languageService("Review"),
    nextTitle: "Confirm",
  },
  SUBMITINPROGRESS: {
    prevPhase: "REVIEW",
    currPhase: "SUBMITINPROGRESS",
    nextPhase: "SUBMITTED",
  },
  SUBMITTED: {
    prevPhase: null,
    currPhase: "SUBMITTED",
    nextPhase: null,
    nextTitle: null,
    currTitle: languageService("Done"),
  },
};



// WEBPACK FOOTER //
// ./src/components/HoursOfService/MyHoursOfService/constants.js